import React from 'react';

const Media = ({ imgSrc, imgAlt, restProp, fallback }) => {
  const handleError = (e) => {
    e.target.src = fallback;
  };
  return (
    <img
      src={imgSrc ? `${imgSrc}?v=${window?.['translations']?.['imgVersion']}` : fallback}
      alt={imgAlt}
      loading='lazy'
      {...restProp}
      onError={handleError}
    />
  );
};

export default Media;
